export default {
  title: 'Mes factures',
  link: 'PDF',
  cardListInvoices: {
    title: 'Factures pour votre déménagement',
    project: 'Dossier n° {numClient}',
    empty: 'Votre facture est actuellement <b>en cours d’édition</b>.<br><b>Elle sera bientôt disponible.</b>',
  },
  tableListInvoices: {
    label: {
      date: 'Date',
      number: 'N° de facture',
      type: 'Type',
      amount_ttc: 'Montant TTC',
      payment: 'Paiement',
      mover: 'Déménageur',
      status: 'Statut',
    }
  },
  factureType: {
    refunded: 'Avoir',
    FACTURE_TYPE_COMM_PCD_SOLDE_CLIENT: 'Solde',
    FACTURE_TYPE_COMM_CLIENT_ARRHES: 'Arrhes',
    FACTURE_TYPE_COMM_CLIENT_SOLDE: 'Solde'
  },
  statusType: {
    refunded: 'Remboursé',
    FACTURE_SENT: "En cours",
    FACTURE_PAID: "Payée",
    FACTURE_LATE: 'En retard',
    FACTURE_PARTIAL: 'Partiel',
    FACTURE_UNPAID: 'Non payée',
    FACTURE_CANCELLED: 'Annulée'
  },
};

